import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import type { ReactNode } from "react";
import {
	AGENT_ACCENTS,
	AGENT_ICONS,
} from "@/components/brand/ai-agent-icons";
import { cn } from "@/lib/utils";

export function ConnectAiDocs({
	className,
	footer,
}: {
	className?: string;
	footer?: ReactNode;
}) {
	return (
		<section
			className={cn(
				"rounded-md border border-border bg-card p-5 sm:p-6",
				className,
			)}
		>
			<header className="space-y-1.5">
				<h2 className="text-base font-medium text-foreground">
					Connect your assistant
				</h2>
				<p className="text-sm leading-relaxed text-muted-foreground">
					Pick your assistant and follow the install.
				</p>
			</header>

			<div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
				<div className="flex flex-col gap-3 rounded-md border border-border bg-background p-4">
					<div className="flex items-center gap-2">
						{AGENT_ICONS.claude(`size-5 ${AGENT_ACCENTS.claude.text}`)}
						<div className="text-sm font-medium text-foreground">Claude</div>
					</div>
					<p className="text-xs leading-relaxed text-muted-foreground">
						Works with Claude Code, web, and desktop.
					</p>
					<Link
						to="/connect-claude"
						className="group mt-auto inline-flex items-center justify-center gap-2 rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
					>
						Add to Claude
						<ArrowRight className="size-3.5 transition-transform group-hover:translate-x-0.5" />
					</Link>
				</div>

				<div className="flex flex-col gap-3 rounded-md border border-border bg-background p-4">
					<div className="flex items-center gap-2">
						{AGENT_ICONS.chatgpt(`size-5 ${AGENT_ACCENTS.chatgpt.text}`)}
						<div className="text-sm font-medium text-foreground">ChatGPT</div>
					</div>
					<p className="text-xs leading-relaxed text-muted-foreground">
						Click through ChatGPT Settings.
					</p>
					<Link
						to="/connect-chatgpt"
						className="group mt-auto inline-flex items-center justify-center gap-2 rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
					>
						Add to ChatGPT
						<ArrowRight className="size-3.5 transition-transform group-hover:translate-x-0.5" />
					</Link>
				</div>
			</div>

			{footer ? (
				<div className="mt-5 border-t border-border pt-4 text-xs leading-relaxed text-muted-foreground">
					{footer}
				</div>
			) : null}
		</section>
	);
}
